(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('[data-pg-reveal]');
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pg-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* Judge.me reviews render async (third-party widget script), so this
     watches the DOM for the first .jdgm-rev card and, once found, injects
     prev/next scroll buttons plus center-detection for the light "peek"
     carousel styled in pg-global.css: whichever card is nearest the
     track's center gets the pg-jdgm-active class (scaled up, full
     opacity, accent border); its neighbors sit dimmed/scaled down.
     No infinite-loop cloning — plain scroll-snap with boundary-aware
     nav buttons, so it degrades safely to plain touch/trackpad scroll
     if anything here fails to attach. */
  function initJdgmPeekCarousel() {
    function findTrack() {
      var card = document.querySelector('.jdgm-rev');
      return card ? card.parentElement : null;
    }

    function cardStep(track) {
      var card = track.querySelector('.jdgm-rev');
      if (!card) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function cardCenterDistance(track, card) {
      var tRect = track.getBoundingClientRect();
      var cRect = card.getBoundingClientRect();
      return Math.abs((cRect.left + cRect.width / 2) - (tRect.left + tRect.width / 2));
    }

    function updateActiveCard(track) {
      var cards = track.querySelectorAll('.jdgm-rev');
      var closest = null;
      var closestDist = Infinity;
      cards.forEach(function (card) {
        var dist = cardCenterDistance(track, card);
        if (dist < closestDist) {
          closestDist = dist;
          closest = card;
        }
      });
      cards.forEach(function (card) {
        card.classList.toggle('pg-jdgm-active', card === closest);
      });
    }

    function buildNav(track) {
      if (track.dataset.pgNavReady) return;
      track.dataset.pgNavReady = 'true';

      var widget = track.parentElement;
      if (!widget) return;

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'pg-jdgm-nav-btn pg-jdgm-nav-prev pg-jdgm-nav-btn--hidden';
      prevBtn.setAttribute('aria-label', 'Previous reviews');
      prevBtn.innerHTML = '&#8249;';

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'pg-jdgm-nav-btn pg-jdgm-nav-next';
      nextBtn.setAttribute('aria-label', 'Next reviews');
      nextBtn.innerHTML = '&#8250;';

      widget.appendChild(prevBtn);
      widget.appendChild(nextBtn);

      function updateState() {
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prevBtn.classList.toggle('pg-jdgm-nav-btn--hidden', atStart);
        nextBtn.classList.toggle('pg-jdgm-nav-btn--hidden', atEnd);
        updateActiveCard(track);
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(track), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(track), behavior: 'smooth' });
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateState, 100);
      });

      updateState();
    }

    var existingTrack = findTrack();
    if (existingTrack) {
      buildNav(existingTrack);
      return;
    }

    var observer = new MutationObserver(function () {
      var track = findTrack();
      if (track) {
        buildNav(track);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initReveal();
    initJdgmPeekCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
